<template>
    <div>
        <div v-if="location.status === 'active'" class="card card-profile shadow">
            <div class="row justify-content-center">
            </div>
            <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                <h3> Nächster Kontrollgang in ...</h3>
                <circular-count-down-timer :key="componentKey" :initial-value="location.tourintervall"
                                           :size="120"
                                           :show-hour="(location.tourintervall > 3600)"
                                           seconds-stroke-color="#2dce89"
                                           minutes-stroke-color="#11cdef"
                                           hours-stroke-color="#f5365c"
                                           hour-label="Stunden"
                                           second-label="Sekunden"
                                           minute-label="Minuten"
                                           @finish="startInspectionTour"
                                           ref="countdown">

                </circular-count-down-timer>
                <!---- Countdown Timer: https://vuejsexamples.com/a-count-down-timer-for-vue-js-framework/ -->
                <!-- <div class="d-flex justify-content-between">
                     <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                     <base-button size="sm" type="default" class="float-right">Message</base-button>
                 </div> --->
            </div>
            <div class="card-body pt-0 pt-md-4">
                <div class="row">
                    <div class="col">

                    </div>
                </div>
                <div class="text-center mb-5">
                    Kontrollgänge dienen der Einhaltung des Jugendschutzgesetzes. Daher ist bei Kontrollgängen insbesondere die Anwesenheit von minderjährigen Gästen zu kontrollieren. <b>Minderjährige Gäste müssen umgehend die Lokalität verlassen</b>.
                </div>
                <footer class="card-footer">
                    <div class="text-center">
                        <a href="#" v-on:click.prevent="showModal">Kontrollgang manuell ausführen</a>
                    </div>
                </footer>
            </div>
        </div>
        <modal :show.sync="show"
               gradient="danger"
               modal-classes="modal-danger modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification">Bitte führen Sie jetzt den nächsten Kontrollgang durch!</h6>
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4">Kontrolle durchführen!</h4>
                <p>Bitte kontrollieren Sie jetzt die Anwesenheit von Minderjährigen</p>


                <select v-model="data.status" class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="status in getStatusCollection" :key="status.id" :value="status['@id']">{{ status.text }}</option>
                </select>
                <textarea v-if="data.status !== defaultS" v-model="data.comment" class="form-control form-control-alternative" rows="3" placeholder="Sofern es einen Vorfall gegeben hat, bitte hier dokumentieren."></textarea>

                <div v-if="getProfile !== null">
                    <p class="lead">Sie signieren diesen Kontrollgang als:<br><b>{{ getProfile.name }}</b></p>
                    <p>Wenn Sie nicht {{ getProfile.name  }} sind, können Sie Ihr Profil <a href="#" @click.prevent="$store.dispatch('profiles/setNoActiveProfile')">hier</a> ändern.</p></div>

            </div>
            <template slot="footer">
                <base-button @click="createInspectionTourAndClose" type="secondary" :disabled="isLoading">abschicken</base-button>
                <p align="right" class="text-sm ">Sekunden bis Kontrollgang automatisch erledigt wird:</p>
                <circular-count-down-timer :key="componentKey2" v-if="show" :initial-value="300"
                                           :size="70"
                                           :show-minute="false"
                                           :show-hour="false"
                                           seconds-stroke-color="#2dce89"
                                           second-label=""
                                           style="text-align: center"
                                           ref="countdown2"
                                           @finish="createInspectionTourAndClose"
                ></circular-count-down-timer>
                <!---<base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="show = false">
                    Close
                </base-button>--->
            </template>
        </modal>
    </div>
</template>
<script>
    import Push from 'push.js';
    const defaultStatus = '/api/statuses/1';

    export default {
        name: 'Kontrollgang',
        data() {
            return {
                data: {
                    profile: null,
                    status: defaultStatus,
                    comment: ''
                },
                location: {
                    tourintervall: 10,
                    status: 'inactive',
                    isInspectiontourReverse: false
                },
                show: false,
                defaultS: defaultStatus,
                componentKey: 0,
                componentKey2: 0,
                response: {},
                isLoading: false
            }
        },
        created() {
            if (!this.$store.getters['location/isReady']) {
                this.$store.dispatch('location/getLocationCollection').then(() =>{
                    this.init()
                })
            } else {
                this.init()
            }
            this.$store.dispatch('status/getStatusCollection');

        },
        mounted() {

        },
        computed: {
            getStatusCollection() {
                return this.$store.getters['status/showStatusCollection'];
            },
            getProfile(){
                return this.$store.getters['profiles/showActiveProfile']
            }
        },
        methods: {
            init() {
                this.location = this.getLocationFromStore(this.$store.getters['authentication/location']);
                if(this.location.isInspectiontourReverse) this.startInspectionTour();
            },
            getLocation(id){ //old function ersetzt durch getLocationFromStore
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations/` + id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve(response);
                        }, error => {reject(error); });
                });
            },
            getLocationFromStore(id){
                return this.$store.getters['location/showLocationByIRI']('/api/locations/'+id);
            },
            updateCountdown (value)  {
                this.$refs.countdown.updateTime(value)
            },
            createInspectionTourAndClose() {
                // create Inspection Tour
                if (this.show) {
                    this.isLoading = true;
                    this.addInspectionTour().then(response => {
                        this.data = {
                            status: defaultStatus,
                            comment: ''
                        };
                        this.response = response;
                        this.isLoading = false;
                        this.componentKey += 1;
                        this.componentKey2 += 1;
                        this.show = false;
                        // eslint-disable-next-line no-console
                        console.log("finishedTour");
                        this.$store.dispatch('alert/clear');
                    }).catch(error => {
                        this.$store.dispatch('alert/error', error);
                        this.componentKey2 += 1;
                        this.isLoading = false;
                    });
                } else {
                    //this.componentKey2 += 1;
                }
            },
            addInspectionTour() {
                return new Promise((resolve, reject) => {
                    if (this.$store.getters['profiles/showActiveProfile'] !== null ) {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    this.data.profile = this.$store.getters['profiles/showActiveProfile']['@id'];
                    let senddata = this.data;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                        fetch(process.env.VUE_APP_API_SERVER + `/api/inspection_tours`, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    resolve(response);
                                },
                                error => {
                                    reject(error);
                                });
                    } else {
                        reject('Kein Profil ausgewählt!');
                        this.showNotification('/sounds/loud.mp3');
                        //this.$refs.countdown2.updateTime('30');
                    }
                    });
            },
            showModal() {
                this.show = true;
                //this.componentKey2 += 1;
                //this.$refs.countdown2.updateTime(300);

            },
            playSound (sound) {
                if(sound) {
                    var audio = new Audio(sound);
                    audio.play();
                }
            },
            startInspectionTour() {
                this.showModal();
                this.showNotification('/sounds/normal.mp3');
            },
            showNotification(sound) {
                this.playSound(sound);
                // eslint-disable-next-line no-console
                console.log("makeTour");
                Push.create("KONTROLLGANG", {
                    body: "Kontrollgang durchführen!",
                    icon: '/img/icons/apple-icon.png',
                    timeout: 2400000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
            }
        }
    }

</script>
